import { change, untouch } from 'redux-form';
import { FORM_NAME } from '../Form';
import fetchProject from '../Services/fetchProject';
import { clearProject } from '../State/project';

export default (event, value) => (dispatch, getState) => {

  dispatch(change(FORM_NAME, 'estimate_id', null))
  dispatch(change(FORM_NAME, 'estimate_optional_ids', []))
  dispatch(untouch(FORM_NAME, 'estimate_id'));

  dispatch(change(FORM_NAME, 'client_contact_id', null))
  dispatch(untouch(FORM_NAME, 'client_contact_id'));

  if (value) {

    // delay fetch, so that state can update with new project_id
    setTimeout(async () => {
      await dispatch(fetchProject());

      const project = getState().modals.Order.project;
      const hasExistingOrders = !!(project && project.orders && project.orders.length > 0);
      dispatch(change(FORM_NAME, 'extra_works', hasExistingOrders ? 1 : 0));  // 0 = New Works, 1 = Extra Works
    });

  } else {

    dispatch(clearProject());

  }

}
